import { useEffect, useState } from 'react';

const useComponentSize = (ref: any) => {
    const [size, setSize] = useState({
        width: 0,
        height: 0,
    });

    useEffect(() => {
        if (ref.current) {
            const { width, height } = ref.current.getBoundingClientRect();
            setSize({ width, height });
        }
    }, [ref.current]);

    return size;
};

export default useComponentSize;
